import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/gem': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M464 0c4.1 0 7.8 2 10.1 5.4l99.9 147.2c2.9 4.4 2.6 10.1-0.7 14.2l-276 340.8c-4.8 5.9-13.8 5.9-18.6 0l-276-340.8c-3.3-4-3.6-9.8-0.7-14.2l100-147.2c2.2-3.4 6-5.4 10-5.4h352zM444.7 48h-56.8l51.7 96h68.4zM242.6 48l-51.6 96h194l-51.7-96h-90.7zM131.3 48l-63.3 96h68.4l51.7-96h-56.8zM88.3 192l119.7 160-68.3-160h-51.4zM191.2 192l96.8 243.3 96.8-243.3h-193.6zM368 352l119.6-160h-51.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/gem.js
// module id = 1746
// module chunks = 0